"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var styled_components_1 = __importDefault(require("styled-components"));
var store_1 = __importDefault(require("@src/store"));
var constants_1 = require("./constants");
var DropDownWrapperStyles = function (props) {
    var theme = props.theme, highlight = props.highlight;
    return {
        padding: theme.space.md,
        background: highlight ? theme.colors.yellow.soft : 'transparent',
        transition: 'background 0.3s ease',
        borderRadius: theme.radii.sm,
        div: {
            background: 'transparent',
        },
    };
};
var DropdownWrapper = styled_components_1["default"]('div')(DropDownWrapperStyles);
var optionStyles = function () { return ({
    display: 'flex',
    alignItems: 'center',
}); };
var StyledOption = styled_components_1["default"]('div')(optionStyles);
var iconStyles = function (props) { return ({
    marginRight: props.theme.space.sm,
}); };
var StyledIcon = styled_components_1["default"](icon_1["default"])(iconStyles);
var OCDropdown = function (_a) {
    var onOCDropDownChange = _a.onOCDropDownChange, selectedChannel = _a.selectedChannel, showChannelChangeError = _a.showChannelChangeError, style = _a.style;
    var _b = react_1.useState([]), options = _b[0], setOptions = _b[1];
    var _c = react_1.useState([]), masterOptions = _c[0], setMasterOptions = _c[1];
    var _d = react_1.useState(null), selectedOption = _d[0], setSelectedOption = _d[1];
    var _e = react_1.useState(null), selectedOptionID = _e[0], setSelectedOptionID = _e[1];
    var _f = react_1.useState(false), highlight = _f[0], setHightlight = _f[1];
    var _g = react_1.useState(false), handleChangeCalled = _g[0], setHandleChangeCalled = _g[1];
    react_1.useEffect(function () {
        var _a, _b;
        if (options.length && selectedChannel) {
            var option = options.filter(function (v) { return v.id === selectedChannel; });
            var remainingOptions = masterOptions.filter(function (v) { return v.id !== selectedChannel; });
            setOptions(remainingOptions);
            // just commenting for now beause if we need something like that in future
            // if (selectedChannel === 5 && !handleChangeCalled) {
            //   setHightlight(true);
            //   setTimeout(() => {
            //     setHightlight(false);
            //   }, 2000);
            // }
            setHandleChangeCalled(false);
            setSelectedOption(((_a = option[0]) === null || _a === void 0 ? void 0 : _a.label) || 'WebSDK');
            setSelectedOptionID(((_b = option[0]) === null || _b === void 0 ? void 0 : _b.id) || 5);
        }
    }, [selectedChannel, masterOptions]);
    react_1.useEffect(function () {
        var allPlatformsData = store_1["default"].getAllPlatformsData();
        if (allPlatformsData.length > 0) {
            var options_1 = [];
            allPlatformsData.forEach(function (channel) {
                options_1.push({
                    text: (react_1["default"].createElement(StyledOption, null,
                        constants_1.CHANNEL_ICONS[channel.value] && (react_1["default"].createElement(StyledIcon, { src: constants_1.CHANNEL_ICONS[channel.value] })),
                        react_1["default"].createElement(text_1["default"], { variant: "body.md" }, channel.title))),
                    label: channel.title,
                    id: channel.value,
                });
            });
            var initalOptions = options_1.filter(function (v) { return v.id !== 5; });
            setMasterOptions(options_1);
            setOptions(initalOptions);
            setSelectedOption(options_1[0].label);
            setSelectedOptionID(options_1[0].id);
        }
    }, []);
    var handleOnChange = function (val) {
        // setHightlight(false);
        setHandleChangeCalled(true);
        if (!showChannelChangeError) {
            setSelectedOption(val.label);
            setSelectedOptionID(val.id);
        }
        onOCDropDownChange(val.id, val.label);
    };
    return (react_1["default"].createElement(DropdownWrapper, { highlight: highlight, style: style }, selectedOption && (react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select a value", themed: true, options: options, value: selectedOption, onChange: function (val) { return handleOnChange(val); }, label: "Channel", icon: constants_1.CHANNEL_ICONS[selectedOptionID] }))));
};
exports["default"] = OCDropdown;
